import { BaseController } from './BaseController';
import { get } from '../Utils/helpers';

export default class ListController extends BaseController {
  id = 'ListController';

  init() {
    this.fetchUrl = '/get-articles';

    this.root = this.getRoot();
    this.articleList = this.singleChildNode('article-list');
    this.btnLoad = this.singleChildNode('btn-load-more');
    this.btnLoad.classList.add('btn-load-show');
    this.spinner = this.singleChildNode('list-spinner-block');

    this.data = {
      currPage: 1,
      request: null,
      lastId: this.articleList.dataset.lastId,
      groupId: this.articleList.dataset.groupId,
      isDone: false,
      spinnerShowClass: 'loading',
      btnShowClass: 'btn-load-show',
    };

    this.btnHideOnDone();
    this.btnLoad.addEventListener('click', this.triggerGet);
  }

  triggerGet = () => {
    this.data.request = get(`${this.fetchUrl}?group_id=${this.data.groupId}&last_id=${this.data.lastId}&lang=${document.documentElement.lang}`, this.getResults);
    this.btnLoad.classList.remove(this.data.btnShowClass);
    this.spinner.classList.add(this.data.spinnerShowClass);
  };

  getResults = () => {
    if (
      this.data.request.readyState === 4 &&
      this.data.request.status === 200
    ) {
      this.spinner.classList.remove(this.data.spinnerShowClass);
      this.btnLoad.classList.add(this.data.btnShowClass);
      
      var returnedData = JSON.parse(this.data.request.response);
      this.articleList.innerHTML += returnedData['articles'];

      this.data.lastId = returnedData['last_id'];

      this.data.isDone = returnedData['is_done'];

      this.btnHideOnDone();

      const listenOnChange = new Event('lazy_load');
      window.dispatchEvent(listenOnChange);
    }
  };

  btnHideOnDone = () => {
    if (this.data.isDone) {
      this.btnLoad.classList.remove('btn-load-show');
    }
  };
}
